import { FC, useCallback } from 'react';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback, useSelectorWithConfig } from 'shared/hooks';
import { selectFlatShareFilter } from 'shared/selectors/advancedFilters/flatShare';

export const FlatShareContainer: FC = () => {
  const { label, value, options, visible } = useSelectorWithConfig(selectFlatShareFilter);

  const onChange = useFilterChangeCallback();

  const handleFlatShareChange = useCallback(
    (newValue: number | null) => {
      onChange({ action: 'setFlatShare', arguments: [newValue] });
    },
    [onChange],
  );

  if (!visible) {
    return null;
  }

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleFlatShareChange} />
    </AdvancedFilterRow>
  );
};
